    import { myFetch, HttpMethod } from './baseService';

// Interfaz para la solicitud de cambio de contraseña
export interface ChangePasswordRequest {
  email: string;
  "Codigo apartamento": string;
  "Tipo usuario": string;
  "Contrasena anterior": string;
  "Contrasena nueva": string;
  "Contrasena nueva confirmacion": string;
}

// Interfaz para los datos del usuario
export interface UserData {
  usu_email: string;
  usu_nombre_completo: string;
  tus_codigo: string;
  tus_nombre: string;
  usu_tipo_documento: string;
  usu_numero_documento: string;
  usu_numero_celular: string;
  ure_codigo: string;
  ure_nombre: string;
  tor_codigo: string;
  tor_nombre: string;
  apt_codigo: string;
  apt_nombre: string;
  usu_ruta_foto: string;
  uau_permiso_para_votar: number;
}

// Interfaz genérica para la respuesta
export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

// Función para cambiar la contraseña
export const changePassword = async (payload: ChangePasswordRequest) => {
  const envelope = await myFetch<ApiEnvelope<UserData[]>>(
    'usuario/ModificarContrasena',
    HttpMethod.POST,
    payload
  );

  return envelope;
};

// Interfaz para la solicitud de ObtenerTodos
export interface ObtenerTodosRequest {
  email: string;
  "Codigo apartamento": string;
  "TipoUsuario": string;
}

// Función para obtener todos los datos del usuario
export const obtenerTodos = async (payload: ObtenerTodosRequest) => {
  const envelope = await myFetch<ApiEnvelope<UserData[]>>(
    'usuario/ObtenerTodos',
    HttpMethod.POST,
    payload
  );

  return envelope;
};

// Interfaz para la solicitud de ModificarDatosPersonales
export interface ModificarDatosPersonalesRequest {
  email: string;
  "apartamento codigo": string;
  "Tipo usuario codigo": string;
  "nombre completo": string;
  "tipo documento codigo": string;
  "numero documento": string;
  "numero celular": string;
}

// Función para modificar datos personales del usuario
export const modificarDatosPersonales = async (payload: ModificarDatosPersonalesRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    'usuario/ModificarDatosPersonales',
    HttpMethod.POST,
    payload
  );

  return envelope;
};

// Interfaz para la solicitud de Modificar_foto
export interface ModificarFotoRequest {
  email: string;
  "apartamento codigo": string;
  "Tipo usuario codigo": string;
  foto_base64: string;
}

// Función para modificar la foto de perfil del usuario
export const modificarFoto = async (payload: ModificarFotoRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    'usuario/Modificar_foto',
    HttpMethod.POST,
    payload
  );

  return envelope;
};

// Interfaz para la solicitud de RecuperarClavePaso1
export interface RecuperarClavePaso1Request {
  email: string;
}

// Función para solicitar el PIN de recuperación
export const recuperarClavePaso1 = async (payload: RecuperarClavePaso1Request) => {
  const envelope = await myFetch<ApiEnvelope<{}>>(
    'usuario/RecuperarClavePaso1',
    HttpMethod.POST,
    payload
  );

  return envelope;
};

// Interfaz para la solicitud de RecuperarClavePaso2
export interface RecuperarClavePaso2Request {
  email: string;
  "pin recuperacion": string;
  "Contrasena nueva": string;
  "Contrasena nueva confirmacion": string;
}

// Función para recuperar la contraseña con el PIN
export const recuperarClavePaso2 = async (payload: RecuperarClavePaso2Request) => {
  const envelope = await myFetch<ApiEnvelope<UserData[]>>(
    'usuario/RecuperarClavePaso2',
    HttpMethod.POST,
    payload
  );

  return envelope;
};